module.exports = __webpack_public_path__ + "img/tilde.6578de4.svg";